"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";
import poiStore from "./pois";
import openedDetailsStore from "./openedDetails";

const poiModificationStore = new Collection({keyNames: ["poi"]});
export default poiModificationStore;

window.poiModificationStore = poiModificationStore;

function updateModifications(poiId, modifications) {
	const document = poiModificationStore.get(poiId);
	if (!document) return;
	Object.assign(document.modifications, modifications);
	poiModificationStore.update(poiId, document);
}

dispatcher.on('modifyPOI', (poiId, modifications) => {
	if (!poiModificationStore.get(poiId)) {
		poiModificationStore.insert([{
			poi: poiId,
			modifications: modifications || {}
		}]);
	} else {
		updateModifications(poiId, modifications);
	}
});

dispatcher.on("restorePOIShape", poiId => {
	const document = poiModificationStore.get(poiId);
	if (!document) return;
	delete document.modifications.location;
	delete document.modifications.radius;
	poiModificationStore.update(poiId, document);
});

poiStore.on("update", poi => {
	poiModificationStore.remove([poi._id]);
});

poiStore.on("remove", pois => {
	poiModificationStore.remove(pois.map(p => p._id));
});

openedDetailsStore.on("remove", detailsDescriptors => {
	poiModificationStore.remove(detailsDescriptors.map(d => d.id));
});


// WEBPACK FOOTER //
// ./src/store/poiModifications.js